import React from "react";
import { Box, Grid } from "@material-ui/core";
import "moment-timezone";
import { useStyles } from "./style";
import emptyImg from "src/assets/images/empty.png";
import Drawer from "./Drawer";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { setSelectedVehicleId, loader } from "src/app-redux/vehicle/vehicleSlice";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { Backdrop } from "@mui/material";
import VehicleImages from "./VehicleImages";
import { getYardTrail } from "src/app-redux/yard/actions/yardActions";
import {
  selectYardRowsSlots,
  loader as yardLoaderr,
  addYardRowRecord,
  addVehicleId,
  drawerOpenedFor,
  selectYardStats,
} from "src/app-redux/yard/yardSlice";
import NoRecordFound from "src/components/NoRecordFound";
import { colorCodeList } from "src/common/utils/app.dropdowns";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {
  yardId: number;
}

export function YardContainer({ yardId }: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  const handleImageClick = (gatePassId: any, vehicleId: any) => {
    dispatch(getVehicleDetailsByIdAction(gatePassId));
    dispatch(getYardTrail(vehicleId));
    dispatch(setSelectedVehicleId(gatePassId));
    dispatch(addVehicleId(vehicleId));
    dispatch(drawerOpenedFor("image"));
    setisDrawerOpen(true);
  };
  const vehicleLoading = useAppSelector(loader);
  const yardLoading = useAppSelector(yardLoaderr);
  const rowsRecord = useAppSelector(selectYardRowsSlots);
  const yardStats = useAppSelector(selectYardStats);

  return (
    <>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Backdrop className={classes.backdrop} open={vehicleLoading || yardLoading}>
        <CommonLoader />
      </Backdrop>
      <Grid>
        <Grid container direction="row" style={{ marginTop: "10px" }}>
          <Grid item xs={7} md={5}>
            {yardStats?.yardConsigmentStats.length ? (
              yardStats.yardConsigmentStats.map((item: any, index: any) => (
                <Grid container direction="row" key={item.consigmentName}>
                  <div
                    style={{
                      width: "15px",
                      height: "15px",
                      margin: "0 10px 10px 0px",
                      borderRadius: "3px",
                      backgroundColor: colorCodeList.find(
                        (st: any) => st.value === item.consigmentColorCode
                      )?.backgroundColor,
                    }}
                  ></div>
                  <Box style={{ marginRight: "5px" }}>
                    <b>{item.consigmentName}: </b>
                  </Box>
                  <Box>
                    {item.count != null
                      ? item.count == 1
                        ? ` ${item.count} Vehicle`
                        : ` ${item.count} Vehicles`
                      : " -"}
                  </Box>
                </Grid>
              ))
            ) : (
              <></>
            )}
          </Grid>
          <Grid item xs={5} md={5}>
            <Box>
              <b>Total Capacity:</b>{" "}
              {yardStats?.totalCapacity != null ? `${yardStats.totalCapacity}` : "-"}
            </Box>
            <Box>
              <b>Occupied Capacity:</b>{" "}
              {yardStats?.occupiedCapacity != null
                ? `${yardStats.occupiedCapacity}/${yardStats.totalCapacity}`
                : "-"}
            </Box>
            <Box>
              <b>Empty Slots:</b>{" "}
              {yardStats?.emptySlots != null
                ? `${yardStats.emptySlots}/${yardStats.totalCapacity}`
                : "-"}
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} className={classes.mainYard}>
          {rowsRecord.length >= 1 ? (
            rowsRecord.map((item: any, index) => (
              <>
                <Grid container md={12} item key={`Row ${item.rowName}`}>
                  <Grid item md={1} className={classes.rowLeftSec}>
                    <Box className={classes.rowTitle}>
                      <h3>Row {item.rowName}</h3>
                      <span>
                        {item.noOfVehicles || "0"}/{item.noOfTotalVehicles}
                      </span>
                    </Box>
                  </Grid>

                  <Grid item md={11} className={classes.rowRightSec}>
                    {/* Slots Start */}
                    {item.slots.map((slotItem: any, index: any) => (
                      <Box key={index + 1} className={classes.vehicleBox}>
                        {slotItem.vehicle === null ? (
                          // Empty Slot
                          <>
                            <span className={classes.vehicleNumberSpan}>{slotItem.slotOrder}</span>
                            <img src={emptyImg} alt="logo" style={{ height: "100%" }} />
                          </>
                        ) : (
                          // Booked Slot
                          <>
                            <span className={classes.vehicleNumberSpan}>{slotItem.slotOrder}</span>
                            <VehicleImages
                              slotItem={slotItem}
                              onClickEvent={() => {
                                dispatch(
                                  addYardRowRecord({
                                    yardId: yardId,
                                    rowId: item.rowId,
                                    slotId: slotItem.slotId,
                                    gatePassId: slotItem.vehicle.gatePassId,
                                  })
                                );
                                handleImageClick(
                                  slotItem.vehicle.gatePassId,
                                  slotItem.vehicle.vehicleId
                                );
                              }}
                              colorCode={slotItem.vehicle.colorCode}
                            />
                          </>
                        )}
                      </Box>
                    ))}
                    {/* Slots END */}
                  </Grid>
                </Grid>
                {/* Row END*/}
              </>
            ))
          ) : (
            <div className={classes.noRecord}>
              <NoRecordFound message={"No Record Found!"} />
            </div>
          )}
        </Grid>
      </Grid>
    </>
  );
}
